// extracted by mini-css-extract-plugin
export default {"videoTag":"PlayerModel_videoTag__szu9w"};